import {API_STATUS_CODE} from "@/config/config";
import {GetItem} from "@/utils/storage";
import {Message} from 'element-ui';

const axios = require('axios');

axios.defaults.timeout = 27000; // gateway default timeout time
axios.defaults.xsrfCookieName = "XSRF-TOKEN"
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN"
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_HOST;

axios.interceptors.request.use(function (config) {
    config.headers["X-XSRF-TOKEN"] = GetItem("_XSRF_")
    if (GetItem("_CRIOS_")) {
        config.headers["CRIOS-COOKIE"] = GetItem("_CRIOS_");
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    // 针对 put 方法上传文件，不拦截
    if (response.config.method.toLowerCase() === 'put') {
        return response
    }
    if (response.data && response.data.data && typeof (response.data.data) === "string") {
        try {
            response.data.data = JSON.parse(response.data.data)
        } catch {
            // data is not JSON
        }
    }
    if (response.data.code !== API_STATUS_CODE.SUCCESS) {
        Message.error("[ERROR][status][" + response.data.code + "][" + response.request.responseURL + "]" + (response.data && response.data.msg || response.data || response.statusText || response.status))
    }
    return response;
}, function (error) {
    console.log('instance.interceptors.response', 'error', error)
    Message.error({message: "[ERROR][catch] " + error});
    return Promise.reject(error);
});

export default axios;